/**
 * Case priority snapshot domain entity.
 * Represents an available priority for a case at a given point in time.
 */
export class CasePrioritySnapshotEntity {
  public id!: string;
  // Canonical code (sla_configurations.priority); PATCH /priority expects this, `name` is display-only.
  public priority!: string;
  public name!: string;
  public code!: string;
  public sortOrder!: number;
  public timeToResolveHours!: number;
  public atRiskThresholdPercent!: number;
  public isActive!: boolean;
}
